import { useCallback, useEffect, useState } from 'react';
import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd';
// import { FilterPayload, getAgentList } from 'api/agent';
import { FileExcelFilled } from '@ant-design/icons';
import xlsx from 'json-as-xlsx';
import FilteredList from '../filterList/FilteredList';
import { FilterPayload, getMandateStatusList, getNachList } from 'api/nach';
import { getSelectList, SelectPayload, SelectResponse } from 'api/dashboard';
import { maskAllDigitsExceptLastFour } from 'features/nach/utils/maskNumber';
import moment from 'moment';

const dateFormat = 'DD/MM/YYYY';
type Props = {
  isLoading: boolean;
  onSubmit: (values: FilterPayload) => Promise<void>;
};
const initSelectResp: SelectResponse = {
  data: [],
};
// const SourceApplicationName = sessionStorage.getItem('source')?.toString();

let filterPayload: FilterPayload = {};

function getFullDate(date: string) {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }
}

const DashboardFilterForm = ({ onSubmit }: Props) => {
  const [bankNameList, setBankNameList] = useState<string[]>([]);
  const [form] = Form.useForm<FilterPayload>();
  const [filter, setFilter] = useState(filterPayload);
  const [_sourceId, setSourceId] = useState(0);
  const [sources, setSource] = useState(initSelectResp);
  const [mandateStatusList, setMandateStatusList] = useState([]);
  // const [statusId, setStatusId] = useState(0);

  const { Option } = Select;

  console.log('Filetr ', filter);

  useEffect(() => {
    getMandateStatusList().then((res) => {
      if (res.status == 'SUCCESS' && res.data) {
        setMandateStatusList(res.data.data);
      }
    });
    // if (isAdmin == 'true') {
    const sourcePayload: SelectPayload = {
      SKey: 'Source',
    };
    getSelectList(sourcePayload).then((res) => {
      setSource(res);
    });
    // }
  }, []);

  const isAdmin = sessionStorage.getItem('isAdmin');
  const handleSubmit = useCallback(
    async (values: FilterPayload) => {
      let updatedValues = { ...values };

      Object.keys(updatedValues).forEach((key) => {
        const typedKey = key as keyof FilterPayload; // Cast the key to a valid key of FilterPayload
        if (updatedValues[typedKey] === '') {
          updatedValues[typedKey] = null;
        }
      });
      // api is not working for it
      // updatedValues.username = sessionStorage.getItem('user')?.toString();
      if (isAdmin != 'true') {
        updatedValues.sourceApplicationName = sessionStorage.getItem('source')?.toString();
      }

      setFilter(updatedValues);
    },
    [onSubmit, form]
  );

  function handleDownload(_e: any) {
    filter.isExtract = true;
    filter.pageNo = 1;
    filter.pageSize = 10;
    console.log('download filter ', filter);

    // api is not working for it

    // filter.username = sessionStorage.getItem('user')?.toString();

    if (isAdmin != 'true') {
      filter.sourceApplicationName = sessionStorage.getItem('source')?.toString();
    }
    getNachList(filter).then((_x) => {
      console.log('nach dashboard ', _x);
      let settings = {
        fileName: 'NACH Dashboard -Report', // Name of the resulting spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
        writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
        RTL: false, // Display the columns from right-to-left (the default value is false)
      };
      const content = _x.data?.data || [];
      const updatedData = content.map((item: any, index) => ({
        ...item,
        AccountNo: maskAllDigitsExceptLastFour(item.accountNo),
        requestDate: getFullDate(item.requestDate),
        mandateStartDate: getFullDate(item.mandateStartDate),
        mandateEndDate: getFullDate(item.mandateEndDate),
        aproveMandateCreatedOn: getFullDate(item.aproveMandateCreatedOn),
        ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
      }));

      let data = [
        {
          sheet: 'Sheet 1',
          columns: [
            { label: 'ROWNUM', value: 'ROWNUM' },
            { label: 'Mandate Request ID', value: 'mandateId' },
            { label: 'Loan Number', value: 'loanNo' },
            { label: 'Loan Type', value: 'loanType' },
            { label: 'Mandate Type(Mode)', value: 'mode' },
            { label: 'Source Application Name', value: 'sourceApplicationName' },
            { label: 'Bank Name', value: 'bankName' },
            { label: 'AcountNo', value: 'AccountNo' },
            { label: 'IFSC Code', value: 'ifscCode' },
            { label: 'Maximum Billing Amount', value: 'maxBillingAmount' },
            { label: 'Mandate Status', value: 'mandateStatus' },
            // { label: 'Verification Reason', value: 'VerificationReason' },
            { label: 'Request Date', value: 'requestDate' },
            { label: 'Mandate Start Date', value: 'mandateStartDate' },
            { label: 'Mandate End Date', value: 'mandateEndDate' },
            { label: 'Mandate Remark', value: 'mandateRemark' },
            { label: 'UMR No', value: 'umrNo' },
            { label: 'Approve Mandate ID', value: 'approvateMandateID' },
            { label: 'Approve Mandate Created On', value: 'aproveMandateCreatedOn' },

            { label: 'CreatedBy', value: 'byAgent' },
          ],
          content: updatedData,
        },
      ];
      xlsx(data, settings);
    });
  }

  // function handleReset(_e: any) {
  //   form.resetFields();
  //   let updatedFilter = { ...filter };
  //   updatedFilter = filterPayload;
  //   setFilter(updatedFilter);
  //   handleSubmit(filterPayload);
  // }
  const handleSourceId = (e: any) => {
    form.setFieldValue('sourceId', e);
    form.validateFields(['sourceId']);
    setSourceId(Number(e));
  };

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = filterPayload;
    setFilter(updatedFilter);
    setBankNameList([...bankNameList]);
  }
  console.log('Filter', filter);

  return (
    <>
      <div className="submission-htmlForm">
        <Form<FilterPayload>
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          scrollToFirstError
          className="standard-forms"
        >
          <div className="row">
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item
                  label={'Mandate Request ID :'}
                  name="mandateId"
                  className="fieldTitle"
                  rules={[
                    {
                      // required: true,
                      type: 'number',
                      message: 'Must be a number',
                    },
                    {
                      validator: (_, value) => {
                        if (value !== undefined && value !== null && value !== '') {
                          if (typeof value !== 'number') {
                            return Promise.reject(new Error('Mandate ID should be a number'));
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={'Enter Mandate ID'}
                    onChange={(value) => {
                      form.setFieldValue('mandateId', value);
                      if (
                        value === null ||
                        (typeof value === 'string' && value.trim() !== '' && isNaN(Number(value)))
                      ) {
                        form.setFields([
                          { name: 'mandateId', errors: ['Mandate ID should be a number'] },
                        ]);
                      } else {
                        form.setFields([{ name: 'mandateId', errors: [] }]);
                      }
                    }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item label={'Loan No :'} name="lanNumber" className="fieldTitle">
                  <Input placeholder={'Enter Loan No'} />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item label={'Mandate Status :'} name="mandateStatus" className="fieldTitle">
                  <Select size="large" placeholder="Select">
                    {/* Add the "Select" option first */}
                    <Option key="select-default" value="">
                      Select
                    </Option>
                    {mandateStatusList.map((status: { SValue: string }, index) => (
                      <Option key={status.SValue + index} value={status.SValue}>
                        {status.SValue}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item label={'Mandate Type (Mode):'} name="mandateType" className="fieldTitle">
                  <Select size="large" placeholder={'Select Mandate Type'}>
                    <Option key={'AUTOPAY'} value={'AUTOPAY'}>
                      AUTOPAY
                    </Option>
                    <Option key={'ENACH'} value={'ENACH'}>
                      ENACH
                    </Option>
                    <Option key={'PNACH'} value={'PNACH'}>
                      PNACH
                    </Option>
                  </Select>
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item
                  label={'Mandate Request Date From:'}
                  name="fromDate"
                  className="fieldTitle"
                >
                  <DatePicker placeholder={'Select From Date'} format={dateFormat} />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item
                  label={'To :'}
                  rules={[
                    {
                      validator(rule, value, callback) {
                        if (value < form.getFieldValue('fromDate')) {
                          rule.message = 'To Date should be greater than From Date';
                          callback('To Date should be greater than From Date');
                        } else {
                          callback();
                        }
                      },
                    },
                  ]}
                  name="toDate"
                  className="fieldTitle"
                >
                  <DatePicker format={dateFormat} placeholder={'Select To Date'} />
                </Form.Item>
              </div>
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item
                  label={'Source Application Name :'}
                  name="sourceApplicationName"
                  className="fieldTitle"
                >
                  <Select
                    placeholder="Select"
                    size="large"
                    // value={statusId.toString()}
                    onSelect={handleSourceId}
                  >
                    {/* <Option value="0">Select</Option> */}
                    {sources.data.map((role) => (
                      <Option value={role.SText}>{role.SText}</Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
            </div>
            {/* Need to remove column Bank Name, Request Status, Gateway Name, Payment ID Drop down
            SourceApplication(refer paymnet dashboard), Mandate Status,Mandate Type (Mode) */}
            <div className="col-xs-12 col-sm-4 col-md-4">
              <div className="input-box">
                <Form.Item label={'UMR No :'} name="umrNo" className="fieldTitle">
                  <Input placeholder={'Enter UMR No'} />
                </Form.Item>
              </div>
            </div>
            <div style={{ float: 'right', marginBottom: '10px', marginTop: '30px' }}>
              <Button
                type="link"
                icon={<FileExcelFilled />}
                style={{ float: 'right', fontSize: '30px', color: 'green' }}
                onClick={handleDownload}
              ></Button>
              &nbsp; &nbsp;
              <Button
                type="primary"
                onClick={handleReset}
                style={{ float: 'right', marginRight: '5px' }}
              >
                {'CLEAR'}
              </Button>
              &nbsp; &nbsp;
              <Button
                type="primary"
                htmlType="submit"
                style={{ float: 'right', marginRight: '10px' }}
              >
                {'SEARCH'}
              </Button>
            </div>
          </div>
        </Form>
      </div>
      <FilteredList filter={{ ...filter }} />
    </>
  );
};

export default DashboardFilterForm;
